import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ElectricComparatorResult } from 'src/app/components/account/models/ElectricComparatorResult';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-comparator-energy-result',
  templateUrl: './comparator-energy-result.component.html',
  styleUrls: ['./comparator-energy-result.component.scss']
})
export class ComparatorEnergyResultComponent implements OnInit {

  @Input('electricComparatorResult') public electricComparatorResult: ElectricComparatorResult;
  @Input('isMobileView') public isMobileView: boolean;
  @Input('isSelectOfferButtonVisible') public isSelectOfferButtonVisible: boolean;
  @Input('comparatorForm') comparatorForm: FormGroup;

  @Output('selectOffer') selectOfferChange = new EventEmitter();

  public offerDetails: string = "Detalii oferta";
  public offerType: string = "Tip oferta:";
  public offerName: string = "Denumire oferta:";
  public productType: string = "Tip produs:";
  public clientType: string = "Tip client caruia i se adreseaza oferta:";
  public offerpriceType: string = "Tip pret oferta:";
  public offerValability: string = "Valabilitatate oferta:";
  public applicationPeriod: string = "Perioada de aplicare:";
  public supplyPrice: string = "Preţ de furnizare:";
  public fixedComponent: string = "Valoare componenta fixa (lei/zi):";
  public cogenerationTax: string = "Taxa cogenerare inalta eficienta (lei/kWh):";
  public certifiedGreenValue: string = "Contravaloare certificate verzi (lei/kWh):";
  public excise: string = "Acciza (lei/kWh):";
  public tva: string = "TVA (%):";
  public invoiceUnitValue: string = "Valoare unitară factură (lei/kWh):";
  public contractPeriod: string = "Perioada contract:";
  public paymentDeadline: string = "Termen de plata:";
  public invoiceSubmissionMethod: string = "Mod transmitere factura:";
  public invoiceFrequency: string = "Frecventa emitere factura:";
  public meterReadingFrequency: string = "Frecventa citire contor:";
  public contractModel: string = "Model contract:";
  public otherCosts: string = "Alte costuri:";
  public electricityAcquisition: string = "Structura achizitie energie electrica in anul";
  public discountsApplied: string = "Reduceri aplicate:";
  public applicationPeriodDiscount: string = "Perioada de aplicare a reducerii:";
  public additionalServicesIncluded: string = "Servicii aditionale incluse:";
  public otherConditions: string = "Alte conditii:";
  public lastupdate: string = "Ultima actualizare:";
  public comparatorDocumentsUrl = environment.comparatorDocumentsUrl + "furnizori/";
  public renewableEnergy: string = "Energie regenerabilă:";
  public invoiceValue: string = "Valoare factură:";
  public invoiceValueComparison: string = "Rezultat comparatie valoare factura oferta tip - valoare factura curenta (%):";
  public economyCost: string = "Economie/Cost suplimentar lunar (lei):";
  public fillInTheCurrentInvoiceValue: string = "(completati valoare factura curenta)";
  public isDetailsExpanded: boolean;
  public selectOffer = "Selecteaza oferta";

  ngOnInit(): void {
  }

  showDetails(): void {
    this.isDetailsExpanded = !this.isDetailsExpanded;
  }

  onConvertToNumber(value: any, decimals?: number): number {
    if (!value) {
      return 0;
    }
    if (typeof value === 'string') {
      value = parseFloat(value.replace(",", ""));
    }
    return decimals ? parseFloat(value.toFixed(decimals)) : value;
  }

}
